import React, {Fragment, ReactElement, useEffect, useState} from 'react';
import AppHeader from '../../components/appbar/AppBar';
import EnrolmentMessage from '../../components/common/EnrolmentMessage';
import EnrolmentForm from '../../components/common/EnrolmentForm';
import Modal from '../../components/modal/Modal';
import {useAppDispatch, useAppSelector} from '../../redux/hooks';
import {useHistory} from 'react-router-dom';
import cogoToast from 'cogo-toast';
import {setUserLoggedIn} from '../../redux/globalSlice';
import {resetState} from '../../redux/customerSearchSlice';
import {setPageName, whatsAppGtmStatus} from '../../lib/tagmanager';
import {pageName, whatsAppStatusMesages} from '../../lib/constants';
import {
  getAccessToken,
  getPhoneNumber,
  getStoreInformation,
  setStoreInformation,
  setUser,
  getUserType,
  setLmrUserStatus,
} from '../../core/localstorage-data';
import {setTourGuide} from '../../redux/tourGuideSlice';
import {
  enrolCustomer,
  error,
  loading,
  userData,
} from '../../redux/userContainerSlice';
import {
  whatsApi,
  whatsappData,
  errorinwhatsapp,
  whatsappDataLoadind,
} from '../../redux/yellowMessengerSlice';
import {HOME_ROUTE_PATH, LANDING_PATH} from '../../routes/route-constants';
import {storeInformation} from '../../redux/storeInformationSlice';
import SuccessToast from '../../components/notifications/SuccessToast';
import ErrorToast from '../../components/notifications/ErrorToast';
import TermsAndCondtion from '../../core/terms-condtion';

interface FormData {
  date: string;
  email: string;
  firstName: string;
  lastName: string;
  gender: string;
  whatsappAPI: boolean;
  pincode:string;
}

const LMRSignUp = (): ReactElement => {
  const navigate = useHistory();
  const accessToken = getAccessToken();
  const UserType = getUserType();
  let mobile: string | null = null;

  mobile = getPhoneNumber();

  const [submitButtonClicked, setSubmitButtonClicked] = useState(false);
  const [whasappstatus, setWhatsappStatus] = useState(false);

  const [isModelOpen, setIsModelOpen] = useState<boolean>(false);
  const users = useAppSelector(userData);

  const userErrorMessage = useAppSelector(error);
  const UserLoadingData = useAppSelector(loading);
  const whatsapiData = useAppSelector(whatsappData);
  const storeInformationData = useAppSelector(storeInformation);
  if (storeInformationData) {
    setStoreInformation(storeInformationData);
  }
  const whatsappAPIHasError = useAppSelector(errorinwhatsapp);
  const whatsapiDataIsLoading = useAppSelector(whatsappDataLoadind);

  const dispatch = useAppDispatch();
  if (UserType === null) {
    navigate.replace(LANDING_PATH);
  }

  useEffect(() => {
    setPageName(pageName.customerEnrollment);
    return () => {
      dispatch(resetState());
      //      localStorage.removeItem('signup');
    };
  }, []);

  useEffect(() => {
    if (
      submitButtonClicked == true &&
      whatsappAPIHasError != '' &&
      whatsapiDataIsLoading == false
    ) {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Something went wrong, Please try again."
        />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
    if (
      submitButtonClicked == true &&
      whatsapiData.message.data.number == mobile
    ) {
      whatsAppGtmStatus(whatsAppStatusMesages.optin);
      dispatch(setTourGuide(true));
      setLmrUserStatus('true');
      //   setlmrStatus(true);
      cogoToast.success(
        <SuccessToast
          title="Success!"
          description="Successfully enrolled for Landmark rewards"
        />,
        {
          hideAfter: 3,
          renderIcon: () => {
            return null;
          },
        },
      );
      navigate.push(HOME_ROUTE_PATH);
      //window.location.href = HOME_ROUTE_PATH;
    }
  }, [whatsapiDataIsLoading, whatsapiData, whatsappAPIHasError]);

  useEffect(() => {
    //when user select whatsapp option and user data comes
    if (
      submitButtonClicked == true &&
      whasappstatus == true &&
      users.message == 'SUCCESS'
    ) {
      dispatch(setUserLoggedIn(true));
      if (mobile !== null) {
        dispatch(whatsApi({mobile}));
      }
      setUser(users);
    }
    // if user select whatsapp and user data has error
    if (
      submitButtonClicked == true &&
      whasappstatus == true &&
      UserLoadingData == false &&
      users.message !== 'SUCCESS'
    ) {
      //error

      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Something went wrong, Please try again."
        />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
    // if user does not select whatsapp and user data is not null
    if (
      submitButtonClicked == true &&
      whasappstatus == false &&
      users.message == 'SUCCESS'
    ) {
      setUser(users);
      dispatch(setUserLoggedIn(true));
      dispatch(setTourGuide(true));
      //TODO may be need to add in future
      setLmrUserStatus('true');
      whatsAppGtmStatus(whatsAppStatusMesages.notOpted);
      cogoToast.success(
        <SuccessToast
          title="Success!"
          description="Successfully enrolled for Landmark rewards"
        />,
        {
          hideAfter: 3,
          renderIcon: () => {
            return null;
          },
        },
      );
      navigate.push(HOME_ROUTE_PATH);
    }
    // if user does not select whatsapp and user data has issue
    if (
      submitButtonClicked == true &&
      whasappstatus == false &&
      UserLoadingData == false &&
      users.message !== 'SUCCESS'
    ) {
      //error

      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Something went wrong, Please try again."
        />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
  }, [users, UserLoadingData, userErrorMessage]);

  function submitHandler(formData: FormData) {
    setSubmitButtonClicked(true);
    setWhatsappStatus(formData.whatsappAPI);
    const storeInfomation = getStoreInformation();
    const storecode = storeInfomation?.store_code;
    const parameters = {
      payload: {
        country: '',
        state: '',
        maritalStatus: '',
        suburbanArea: '',
        pinCode: `${formData.pincode}`,
        //        storeCode: '1342',
        storeCode: storecode,
        source: 'MAXBUDDY',
        city: '',
        address1: '',
        occupation: '',
        motherTongue: '',
        mobileNumber: mobile,
        firstName: formData.firstName,
        lastName: formData.lastName,
        emailID: formData.email,
        dateOfBirth: formData.date,
        gender: formData.gender,
        //whatsappAPI: formData.whatsappAPI,
      },

      accessToken: accessToken,
    };
    dispatch(enrolCustomer(parameters));
  }

  return (
    <Fragment>
      <div className="container mx-auto absolute left-0 top-0 bottom-0 right-0">
        <AppHeader bgColor="transparent" />

        <div className="w-auto p-4 md:p-16 top-spacing-ipad">
          <EnrolmentMessage buttonTitle="Create profile" userType={UserType} />

          <EnrolmentForm
            buttonTitle="Create profile"
            submitCallback={submitHandler}
            openTnCModal={() => {
              setIsModelOpen(true);
            }}
          />
        </div>
      </div>
      {isModelOpen && (
        <Modal
          title="Terms And Conditions"
          isVisible={isModelOpen}
          onModalClosed={() => {
            setIsModelOpen(false);
          }}>
          <TermsAndCondtion />
        </Modal>
      )}
    </Fragment>
  );
};

export default LMRSignUp;
